<template>
  <div>
    <div>
      <label class="text-base font-bold text-white/75"
        >Waterfront</label
      >
    </div>
    <div class="">
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="Gulf"
          class="checkbox-input"
          v-model="values.gulf"
        />
        <span class="checkbox-label">Gulf</span>
      </label>
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="Bay"
          class="checkbox-input"
          v-model="values.bay"
        />
        <span class="checkbox-label">Bay</span>
      </label>
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="All"
          class="checkbox-input"
          v-model="values.any"
        />
        <span class="checkbox-label">Any</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaterfrontField",

  props: {
    fieldValue: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      values: {
        gulf: false,
        bay: false,
        any: false
      }
    }
  },

  computed: {
    waterfront () {
      let values = []
      if(this.values.gulf) {
        values.push('Gulf')
      }
      if(this.values.bay) {
        values.push('Bay')
      }
      if(this.values.any) {
        values.push('Gulf|Bay|Canal|Creek|River|Intracoastal|Lake|Bayou|Lagoon|Pond')
      }
      return values.join('|')
    }
  },

  watch: {
    waterfront(val){
      this.$emit('updated', {
        property: 'waterfront',
        value: val
      })
    },
  },

  mounted() {
    this.values.gulf = this.fieldValue.includes('Gulf')
    this.values.bay = this.fieldValue.includes('Bay')
    this.values.any = this.fieldValue.includes('Any')
  },
};
</script>
